export { default, getStaticProps } from 'containers/HomePage/HomePage';
